import { render } from "./ModalProfileLogistic.vue?vue&type=template&id=6d04b3bb"
import script from "./ModalProfileLogistic.vue?vue&type=script&lang=js"
export * from "./ModalProfileLogistic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__